(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_4964af7"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lb-hero-split')) {
    class LbHeroSplit extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.currentSlide = 0;
        this.track = this.querySelector('.lb-hero__track');
        this.slides = [...this.querySelectorAll('.lb-hero__panel')];
        this.dots = [...this.querySelectorAll('.lb-hero__dot')];
        this.previousButton = this.querySelector('.lb-hero__arrow--previous');
        this.nextButton = this.querySelector('.lb-hero__arrow--next');
        this.autoplayInterval = Number.parseInt(this.dataset.autoplayInterval, 10) || 5000;
        this.mobileMedia = window.matchMedia('(max-width: 989px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplayTimer = null;
        this.touchStartX = 0;
        this.touchStartY = 0;

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.showSlide(index, true));
        });

        this.previousButton?.addEventListener('click', () => this.showSlide(this.currentSlide - 1, true));
        this.nextButton?.addEventListener('click', () => this.showSlide(this.currentSlide + 1, true));

        this.track.addEventListener('touchstart', (event) => {
          const touch = event.touches[0];
          this.touchStartX = touch.clientX;
          this.touchStartY = touch.clientY;
          this.stopAutoplay();
        }, { passive: true });

        this.track.addEventListener('touchend', (event) => {
          const touch = event.changedTouches[0];
          const deltaX = touch.clientX - this.touchStartX;
          const deltaY = touch.clientY - this.touchStartY;

          if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
            this.showSlide(deltaX < 0 ? this.currentSlide + 1 : this.currentSlide - 1);
          }

          this.startAutoplay();
        }, { passive: true });

        // Only bind hover pausing on real pointer devices. On touch screens a tap
        // fires mouseenter but never mouseleave, which would kill autoplay for good.
        if (window.matchMedia('(hover: hover)').matches) {
          this.addEventListener('mouseenter', () => this.stopAutoplay());
          this.addEventListener('mouseleave', () => this.startAutoplay());
        }

        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());

        this.onVisibilityChange = () => {
          if (document.hidden) {
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }
        };

        this.onViewportChange = () => {
          this.updateSlideState();
          this.startAutoplay();
        };

        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.mobileMedia.addEventListener('change', this.onViewportChange);
        this.reducedMotion.addEventListener('change', this.onViewportChange);

        this.updateSlideState();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.mobileMedia?.removeEventListener('change', this.onViewportChange);
        this.reducedMotion?.removeEventListener('change', this.onViewportChange);
      }

      showSlide(index, restartAutoplay = false) {
        const total = this.slides.length;
        if (!total) return;

        this.currentSlide = (index + total) % total;
        this.updateSlideState();

        if (restartAutoplay) {
          this.stopAutoplay();
          this.startAutoplay();
        }
      }

      updateSlideState() {
        const isMobile = this.mobileMedia.matches;
        const offset = isMobile ? this.currentSlide * 100 : 0;
        this.track.style.transition = this.reducedMotion.matches ? 'none' : '';
        this.track.style.transform = `translate3d(-${offset}%, 0, 0)`;

        this.slides.forEach((slide, index) => {
          const content = slide.querySelector('.lb-hero__content');
          const isInactive = isMobile && index !== this.currentSlide;

          // Never use `inert` here: some themes style [inert] and the slide
          // renders blank on mobile. Pointer-events is enough.
          slide.removeAttribute('inert');
          slide.style.pointerEvents = isInactive ? 'none' : '';

          if (content) {
            if (isMobile) {
              content.setAttribute('aria-hidden', String(isInactive));
            } else {
              content.removeAttribute('aria-hidden');
            }
          }
        });

        this.dots.forEach((dot, index) => {
          const active = index === this.currentSlide;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      startAutoplay() {
        this.stopAutoplay();

        // Reduced motion removes the sliding animation (handled in updateSlideState),
        // but the slides still need to rotate, otherwise slide 2 is never seen.
        if (!this.mobileMedia.matches || document.hidden || this.slides.length < 2) {
          return;
        }

        this.autoplayTimer = window.setInterval(() => {
          this.showSlide(this.currentSlide + 1);
        }, this.autoplayInterval);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          window.clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }
    }

    customElements.define('lb-hero-split', LbHeroSplit);
  }
  } catch(e) { console.error(e); }
})();

})();
